module.exports = __webpack_public_path__ + "img/info-client-icon.ff5e2a32.svg";